<div
    class="d-block d-lg-none offcanvas-menu position-relative bg-light"
    id="mobileNav"
>
    <div class="offcanvas-header d-flex justify-content-start pb-1">
        @if (mobileTier === 2) {
        <a
            (click)="toggleMobileTier(1, mobileTierChildren, primaryTierItem)"
            class="
                py-0
                ps-0 ps-sm-3
                d-flex
                align-items-center
                fs-5
                header_button
            "
            role="button"
        >
            <span class="back-icon pe-1">
                <img
                    [src]="'GLOBAL_ARROW-LEFT_ICON_URL' | translate"
                    [alt]="'GLOBAL_ARROW-LEFT_ICON_ALT_TEXT' | translate"
                    class="bi arrow-icon"
                />
            </span>
            <div
                [innerHtml]="
                    primaryTierItem['title-translated'] || primaryTierItem.title
                "
                class="align-self-center text-left fw-light text-gray-80"
            ></div>
        </a>
        } @if (mobileTier === 3) {
        <a
            (click)="toggleMobileTier(2, mobileTierChildren, primaryTierItem)"
            class="
                py-0
                ps-0 ps-sm-3
                d-flex
                align-items-center
                fs-5
                header_button
            "
            role="button"
        >
            <span class="back-icon pe-1">
                <img
                    [src]="'GLOBAL_ARROW-LEFT_ICON_URL' | translate"
                    [alt]="'GLOBAL_ARROW-LEFT_ICON_ALT_TEXT' | translate"
                    class="bi arrow-icon"
                />
            </span>
            <div
                [innerHtml]="
                    secondaryTierItem['title-translated'] ||
                    secondaryTierItem.title
                "
                class="align-self-center text-left fw-light text-gray-80"
            ></div>
        </a>
        }

        <button
            type="button"
            class="btn-close py-1 px-1 px-sm-4"
            data-bs-dismiss="offcanvas"
            data-bs-target="#offcanvas"
            data-bs-theme="light"
            aria-label="Close"
        ></button>
    </div>

    @if (navData) {
    <div id="offcanvasBody" class="offcanvas-body mobile_menu-tier">
        <!-- Tier 1 - Top level navigation -->
        @if (mobileTier === 1) { @for (topNavItem of navData; track topNavItem)
        { @if (topNavItem['has-dropdown'] === 'Yes') {
        <a
            (click)="toggleMobileTier(2, topNavItem.navItems, topNavItem)"
            class="
                px-0 px-sm-3
                py-1
                d-flex
                justify-content-between
                align-items-center
                mobile-nav_link
            "
            role="button"
        >
            <div
                [innerHtml]="topNavItem['title-translated'] || topNavItem.title"
                class="link text-gray-80 lead"
            ></div>
            <span>
                <img
                    [src]="'GLOBAL_ARROW-RIGHT_ICON_URL' | translate"
                    [alt]="'GLOBAL_ARROW-RIGHT_ICON_ALT_TEXT' | translate"
                    class="bi arrow-icon"
                />
            </span>
        </a>
        } @else if (topNavItem['has-dropdown'] === 'No' && topNavItem['link']) {
        <div class="px-0 px-sm-3 py-1 d-flex justify-content-between">
            <a
                [attr.data-bs-dismiss]="
                    topNavItem.link?.includes('http') ? null : 'offcanvas'
                "
                [attr.data-bs-target]="
                    topNavItem.link?.includes('http') ? null : '#offcanvas'
                "
                [innerHtml]="topNavItem['title-translated'] || topNavItem.title"
                [brandHref]="topNavItem['link']"
                class="link text-gray-80 lead"
                role="button"
            ></a>
        </div>
        } } }

        <!-- Mobile Tier 2 -->
        @if (mobileTier === 2) { @if (primaryTierItem['featured-link']) {

        <a
            [brandHref]="primaryTierItem['featured-link']"
            data-bs-dismiss="offcanvas"
            data-bs-target="#offcanvas"
            class="
                px-0 px-sm-3
                py-1
                d-flex
                justify-content-between
                featured-link
            "
        >
            <div
                [innerHtml]="primaryTierItem['featured-link-text']"
                class="link lead text-gray-80"
            ></div>
            <span>
                <img
                    [src]="'GLOBAL_ARROW-RIGHT_ICON_URL' | translate"
                    [alt]="'GLOBAL_ARROW-RIGHT_ICON_ALT_TEXT' | translate"
                    class="bi arrow-icon"
                />
            </span>
        </a>
        } @for (categoryItem of mobileTierChildren; track categoryItem) { @if
        (categoryItem.type === 'Heading') {
        <a
            (click)="
                toggleMobileTier(
                    3,
                    mobileTierChildren,
                    categoryItem,
                    categoryItem.column
                )
            "
            class="
                px-0 px-sm-3
                py-1
                d-flex
                justify-content-between
                mobile-nav_link
            "
            role="button"
        >
            <div
                [innerHtml]="
                    categoryItem['title-translated'] || categoryItem.title
                "
                class="link lead text-gray-80"
            ></div>
            <span>
                <img
                    [src]="'GLOBAL_ARROW-RIGHT_ICON_URL' | translate"
                    [alt]="'GLOBAL_ARROW-RIGHT_ICON_ALT_TEXT' | translate"
                    class="bi arrow-icon"
                />
            </span>
        </a>
        } } }

        <!-- mobile tier 3 -->
        @if (mobileTier === 3) {
        <!-- Pass a no-sort compareFn to preserve original order -->
        @for (item of mobileTierChildren | keyvalue: originalOrder; track item)
        { @if(item.value.column === columnValue) { @if (item.value.type ===
        'Heading' && item.value['link-url']) {
        <div class="px-0 px-sm-3 py-1 d-flex justify-content-between">
            <a
                [innerHtml]="item.value['title-translated'] || item.value.title"
                [brandHref]="item.value['link-url']"
                class="heading fw-semibold text-gray-90"
                data-bs-dismiss="offcanvas"
                data-bs-target="#offcanvas"
                role="button"
            ></a>
        </div>
        } @if (item.value.type === 'Sub-heading' && item.value['link-url']) {
        <div class="px-0 px-sm-3 py-1 d-flex justify-content-between">
            <a
                [innerHtml]="item.value['title-translated'] || item.value.title"
                [brandHref]="item.value['link-url']"
                class="sub-heading fw-semibold text-navy-blue"
                data-bs-dismiss="offcanvas"
                data-bs-target="#offcanvas"
                role="button"
            ></a>
        </div>
        } @if (item.value.type === 'Page' && item.value['link-url']) {
        <div class="px-0 px-sm-3 py-1 d-flex justify-content-between">
            <a
                [innerHtml]="item.value['title-translated'] || item.value.title"
                [brandHref]="item.value['link-url']"
                class="link text-gray-80"
                data-bs-dismiss="offcanvas"
                data-bs-target="#offcanvas"
                role="button"
            ></a>
        </div>
        } } } }
    </div>
    }
</div>
